import template from "./hb-dialog.mjs";
import { render } from "lit-html";

//import Strings from "../../../models/Strings.json";
//const strings: any = Strings;

export class HbDialog extends HTMLElement {
    private dialog: HTMLDialogElement;
    private dialogMessage: HTMLParagraphElement;

    private dialog1: HTMLLIElement;
    private dialog1a: HTMLSpanElement;
    private dialog1b: SVGElement;
    private dialog1c: SVGPathElement;
    private dialog1d = "";

    private dialog2: HTMLLIElement;
    private dialog2a: HTMLSpanElement;
    private dialog2b: SVGElement;
    private dialog2c: SVGPathElement;
    private dialog2d = "";

    private dialog3: HTMLLIElement;
    private dialog3a: HTMLSpanElement;
    private dialog3b: SVGElement;
    private dialog3c: SVGPathElement;
    private dialog3d = "";

    private readonly dialogCheckmark =
        "M530.8 134.1C545.1 144.5 548.3 164.5 537.9 178.8L281.9 530.8C276.4 538.4 267.9 543.1 258.5 543.9C249.1 544.7 240 541.2 233.4 534.6L105.4 406.6C92.9 394.1 92.9 373.8 105.4 361.3C117.9 348.8 138.2 348.8 150.7 361.3L252.2 462.8L486.2 141.1C496.6 126.8 516.6 123.6 530.9 134z";

    constructor() {
        super();
        render(template(null), this);

        this.dialog = this.querySelector("#hb-dialog")!;
        this.dialogMessage = this.querySelector("#hb-dialog-message")!;

        this.dialog1 = this.querySelector("#hb-dialog-1")!;
        this.dialog1a = this.dialog1.firstElementChild as HTMLSpanElement;
        this.dialog1b = this.dialog1a.firstElementChild as SVGElement;
        this.dialog1c = this.dialog1b.firstElementChild as SVGPathElement;

        this.dialog2 = this.querySelector("#hb-dialog-2")!;
        this.dialog2a = this.dialog2.firstElementChild as HTMLSpanElement;
        this.dialog2b = this.dialog2a.firstElementChild as SVGElement;
        this.dialog2c = this.dialog2b.firstElementChild as SVGPathElement;

        this.dialog3 = this.querySelector("#hb-dialog-3")!;
        this.dialog3a = this.dialog3.firstElementChild as HTMLSpanElement;
        this.dialog3b = this.dialog3a.firstElementChild as SVGElement;
        this.dialog3c = this.dialog3b.firstElementChild as SVGPathElement;
    }

    connectedCallback() {}

    show(step: "silver" | "jewel" | "chest") {
        //this.dialog1c.removeAttribute("transform");
        this.dialog3c.removeAttribute("transform");
        switch (step) {
            case "silver":
                this.dialog1d =
                    "M256 160L256 224L384 224L384 160C384 124.7 355.3 96 320 96C284.7 96 256 124.7 256 160zM192 224L192 160C192 89.3 249.3 32 320 32C390.7 32 448 89.3 448 160L448 224C483.3 224 512 252.7 512 288L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 288C128 252.7 156.7 224 192 224z";
                this.dialog2d =
                    "M192 192C192 174.3 206.3 160 224 160C241.7 160 256 174.3 256 192L256 199.8C256 227.5 253.6 255.1 248.9 282.3L164.5 307.6C123.9 319.8 96.1 357.2 96.1 399.6L96.1 432L24.1 432C10.8 432 .1 442.7 .1 456C.1 469.3 10.8 480 24.1 480L96.6 480C100.8 516 131.4 544 168.6 544C194.6 544 218.6 530.1 231.5 507.5L245.4 483.2C272.2 436.2 291.9 385.5 303.8 332.7L398.2 304.4L385.7 341.9C382.4 351.7 384.1 362.4 390.1 370.7C396.1 379 405.7 384 416 384L544 384C561.7 384 576 369.7 576 352C576 334.3 561.7 320 544 320L460.4 320L478.4 266.1C482.2 254.8 479.3 242.3 471 233.7C462.7 225.1 450.3 221.9 438.8 225.3L316.4 262.1C318.8 241.4 320 220.7 320 199.8L320 192C320 139 277 96 224 96C171 96 128 139 128 192L128 224C128 241.7 142.3 256 160 256C177.7 256 192 241.7 192 224L192 192zM182.8 369L231.8 354.3C221.4 388.1 207.3 420.7 189.7 451.5L175.8 475.8C174.3 478.4 171.5 480.1 168.4 480.1C163.7 480.1 159.9 476.3 159.9 471.6L159.9 399.7C159.9 385.6 169.2 373.1 182.7 369zM616 480C629.3 480 640 469.3 640 456C640 442.7 629.3 432 616 432L323.1 432C316.6 448.3 309.4 464.3 301.5 480L616 480z";
                this.dialog3c.setAttribute("transform", "rotate(45 300 300)");
                this.dialog3d =
                    "M305 151.1L320 171.8L335 151.1C360 116.5 400.2 96 442.9 96C516.4 96 576 155.6 576 229.1L576 231.7C576 343.9 436.1 474.2 363.1 529.9C350.7 539.3 335.5 544 320 544C304.5 544 289.2 539.4 276.9 529.9C203.9 474.2 64 343.9 64 231.7L64 229.1C64 155.6 123.6 96 197.1 96C239.8 96 280 116.5 305 151.1z";
                break;
            case "jewel":
                this.dialog1d =
                    "M128 96C92.7 96 64 124.7 64 160L64 480C64 515.3 92.7 544 128 544C128 561.7 142.3 576 160 576C177.7 576 192 561.7 192 544L448 544C448 561.7 462.3 576 480 576C497.7 576 512 561.7 512 544C547.3 544 576 515.3 576 480L576 160C576 124.7 547.3 96 512 96L128 96zM320 320C320 284.7 291.3 256 256 256C220.7 256 192 284.7 192 320C192 355.3 220.7 384 256 384C291.3 384 320 355.3 320 320zM128 320C128 249.3 185.3 192 256 192C326.7 192 384 249.3 384 320C384 390.7 326.7 448 256 448C185.3 448 128 390.7 128 320zM512 272C512 289.8 502.3 305.3 488 313.6L488 392C488 405.3 477.3 416 464 416C450.7 416 440 405.3 440 392L440 313.6C425.7 305.3 416 289.8 416 272C416 245.5 437.5 224 464 224C490.5 224 512 245.5 512 272z";
                this.dialog2d =
                    "M348 62.7C330.7 52.7 309.3 52.7 292 62.7L207.8 111.3C190.5 121.3 179.8 139.8 179.8 159.8L179.8 261.7L91.5 312.7C74.2 322.7 63.5 341.2 63.5 361.2L63.5 458.5C63.5 478.5 74.2 497 91.5 507L175.8 555.6C193.1 565.6 214.5 565.6 231.8 555.6L320.1 504.6L408.4 555.6C425.7 565.6 447.1 565.6 464.4 555.6L548.5 507C565.8 497 576.5 478.5 576.5 458.5L576.5 361.2C576.5 341.2 565.8 322.7 548.5 312.7L460.2 261.7L460.2 159.8C460.2 139.8 449.5 121.3 432.2 111.3L348 62.7zM296 356.6L296 463.1L207.7 514.1C206.5 514.8 205.1 515.2 203.7 515.2L203.7 409.9L296 356.6zM527.4 357.2C528.1 358.4 528.5 359.8 528.5 361.2L528.5 458.5C528.5 461.4 527 464 524.5 465.4L440.2 514C439 514.7 437.6 515.1 436.2 515.1L436.2 409.8L527.4 357.2zM412.3 159.8L412.3 261.7L320 315L320 208.5L411.2 155.9C411.9 157.1 412.3 158.5 412.3 159.9z";
                this.dialog3c.setAttribute("transform", "rotate(45 300 300)");
                this.dialog3d =
                    "M305 151.1L320 171.8L335 151.1C360 116.5 400.2 96 442.9 96C516.4 96 576 155.6 576 229.1L576 231.7C576 343.9 436.1 474.2 363.1 529.9C350.7 539.3 335.5 544 320 544C304.5 544 289.2 539.4 276.9 529.9C203.9 474.2 64 343.9 64 231.7L64 229.1C64 155.6 123.6 96 197.1 96C239.8 96 280 116.5 305 151.1z";
                break;
            case "chest":
                this.dialog1d =
                    "M415.9 274.5C428.1 271.2 440.9 277 446.4 288.3L465 325.9C475.3 327.3 485.4 330.1 494.9 334L529.9 310.7C540.4 303.7 554.3 305.1 563.2 314L582.4 333.2C591.3 342.1 592.7 356.1 585.7 366.5L562.4 401.4C564.3 406.1 566 411 567.4 416.1C568.8 421.2 569.7 426.2 570.4 431.3L608.1 449.9C619.4 455.5 625.2 468.3 621.9 480.4L614.9 506.6C611.6 518.7 600.3 526.9 587.7 526.1L545.7 523.4C539.4 531.5 532.1 539 523.8 545.4L526.5 587.3C527.3 599.9 519.1 611.3 507 614.5L480.8 621.5C468.6 624.8 455.9 619 450.3 607.7L431.7 570.1C421.4 568.7 411.3 565.9 401.8 562L366.8 585.3C356.3 592.3 342.4 590.9 333.5 582L314.3 562.8C305.4 553.9 304 540 311 529.5L334.3 494.5C332.4 489.8 330.7 484.9 329.3 479.8C327.9 474.7 327 469.6 326.3 464.6L288.6 446C277.3 440.4 271.6 427.6 274.8 415.5L281.8 389.3C285.1 377.2 296.4 369 309 369.8L350.9 372.5C357.2 364.4 364.5 356.9 372.8 350.5L370.1 308.7C369.3 296.1 377.5 284.7 389.6 281.5L415.8 274.5zM448.4 404C424.1 404 404.4 423.7 404.5 448.1C404.5 472.4 424.2 492 448.5 492C472.8 492 492.5 472.3 492.5 448C492.4 423.6 472.7 404 448.4 404zM224.9 18.5L251.1 25.5C263.2 28.8 271.4 40.2 270.6 52.7L267.9 94.5C276.2 100.9 283.5 108.3 289.8 116.5L331.8 113.8C344.3 113 355.7 121.2 359 133.3L366 159.5C369.2 171.6 363.5 184.4 352.2 190L314.5 208.6C313.8 213.7 312.8 218.8 311.5 223.8C310.2 228.8 308.4 233.8 306.5 238.5L329.8 273.5C336.8 284 335.4 297.9 326.5 306.8L307.3 326C298.4 334.9 284.5 336.3 274 329.3L239 306C229.5 309.9 219.4 312.7 209.1 314.1L190.5 351.7C184.9 363 172.1 368.7 160 365.5L133.8 358.5C121.6 355.2 113.5 343.8 114.3 331.3L117 289.4C108.7 283 101.4 275.6 95.1 267.4L53.1 270.1C40.6 270.9 29.2 262.7 25.9 250.6L18.9 224.4C15.7 212.3 21.4 199.5 32.7 193.9L70.4 175.3C71.1 170.2 72.1 165.2 73.4 160.1C74.8 155 76.4 150.1 78.4 145.4L55.1 110.5C48.1 100 49.5 86.1 58.4 77.2L77.6 58C86.5 49.1 100.4 47.7 110.9 54.7L145.9 78C155.4 74.1 165.5 71.3 175.8 69.9L194.4 32.3C200 21 212.7 15.3 224.9 18.5zM192.4 148C168.1 148 148.4 167.7 148.4 192C148.4 216.3 168.1 236 192.4 236C216.7 236 236.4 216.3 236.4 192C236.4 167.7 216.7 148 192.4 148z";
                this.dialog2d =
                    "M451.5 160C434.9 160 418.8 164.5 404.7 172.7C388.9 156.7 370.5 143.3 350.2 133.2C378.4 109.2 414.3 96 451.5 96C537.9 96 608 166 608 252.5C608 294 591.5 333.8 562.2 363.1L491.1 434.2C461.8 463.5 422 480 380.5 480C294.1 480 224 410 224 323.5C224 322 224 320.5 224.1 319C224.6 301.3 239.3 287.4 257 287.9C274.7 288.4 288.6 303.1 288.1 320.8C288.1 321.7 288.1 322.6 288.1 323.4C288.1 374.5 329.5 415.9 380.6 415.9C405.1 415.9 428.6 406.2 446 388.8L517.1 317.7C534.4 300.4 544.2 276.8 544.2 252.3C544.2 201.2 502.8 159.8 451.7 159.8zM307.2 237.3C305.3 236.5 303.4 235.4 301.7 234.2C289.1 227.7 274.7 224 259.6 224C235.1 224 211.6 233.7 194.2 251.1L123.1 322.2C105.8 339.5 96 363.1 96 387.6C96 438.7 137.4 480.1 188.5 480.1C205 480.1 221.1 475.7 235.2 467.5C251 483.5 269.4 496.9 289.8 507C261.6 530.9 225.8 544.2 188.5 544.2C102.1 544.2 32 474.2 32 387.7C32 346.2 48.5 306.4 77.8 277.1L148.9 206C178.2 176.7 218 160.2 259.5 160.2C346.1 160.2 416 230.8 416 317.1C416 318.4 416 319.7 416 321C415.6 338.7 400.9 352.6 383.2 352.2C365.5 351.8 351.6 337.1 352 319.4C352 318.6 352 317.9 352 317.1C352 283.4 334 253.8 307.2 237.5z";
                this.dialog3c.setAttribute("transform", "rotate(45 300 300)");
                this.dialog3d =
                    "M305 151.1L320 171.8L335 151.1C360 116.5 400.2 96 442.9 96C516.4 96 576 155.6 576 229.1L576 231.7C576 343.9 436.1 474.2 363.1 529.9C350.7 539.3 335.5 544 320 544C304.5 544 289.2 539.4 276.9 529.9C203.9 474.2 64 343.9 64 231.7L64 229.1C64 155.6 123.6 96 197.1 96C239.8 96 280 116.5 305 151.1z";
                break;
        }

        this.render0();
        this.dialog.showModal();
    }

    hide() {
        this.dialog.close();
    }

    renderMessage(message: string, color?: string) {
        if (color !== undefined) this.dialogMessage.style.color = color;
        this.dialogMessage.textContent = message;
    }

    private render0() {
        this.render1a(false);
        this.render1b(false);

        this.render2a(false);
        this.render2b(false);

        this.render3a(false);
        this.render3b(false);
    }

    render1() {
        this.render1a(true);
        this.render1b(true);

        this.render2a(true);
        this.render2b(true);

        this.render3a(true);
        this.render3b(true);
    }

    render1a(isChecked: boolean) {
        if (isChecked) {
            this.dialog1a.classList.remove("bg-gray-100", "dark:bg-gray-600");
            this.dialog1a.classList.add("bg-blue-100", "dark:bg-blue-800");
            this.dialog1b.classList.remove(
                "text-gray-500",
                "dark:text-gray-100"
            );
            this.dialog1b.classList.add("text-blue-600", "dark:text-blue-300");
            this.dialog1c.setAttribute("d", this.dialogCheckmark);
            this.dialog1c.removeAttribute("transform");
        } else {
            this.dialog1a.classList.add("bg-gray-100", "dark:bg-gray-600");
            this.dialog1a.classList.remove("bg-blue-100", "dark:bg-blue-800");
            this.dialog1b.classList.add("text-gray-500", "dark:text-gray-100");
            this.dialog1b.classList.remove(
                "text-blue-600",
                "dark:text-blue-300"
            );
            this.dialog1c.setAttribute("d", this.dialog1d);
        }
    }

    render1b(isChecked: boolean) {
        if (isChecked) {
            this.dialog1.classList.remove(
                //"text-gray-600",
                //"dark:text-gray-500",
                "after:border-gray-100",
                "dark:after:border-gray-600"
            );
            this.dialog1.classList.add(
                //"text-blue-600",
                //"dark:text-blue-500",
                "after:border-blue-100",
                "dark:after:border-blue-800"
            );
        } else {
            this.dialog1.classList.add(
                //"text-gray-600",
                //"dark:text-gray-500",
                "after:border-gray-100",
                "dark:after:border-gray-600"
            );
            this.dialog1.classList.remove(
                //"text-blue-600",
                //"dark:text-blue-500",
                "after:border-blue-100",
                "dark:after:border-blue-800"
            );
        }
    }

    render2a(isChecked: boolean) {
        if (isChecked) {
            this.dialog2a.classList.remove("bg-gray-100", "dark:bg-gray-600");
            this.dialog2a.classList.add("bg-blue-100", "dark:bg-blue-800");
            this.dialog2b.classList.remove(
                "text-gray-500",
                "dark:text-gray-100"
            );
            this.dialog2b.classList.add("text-blue-600", "dark:text-blue-300");
            this.dialog2c.setAttribute("d", this.dialogCheckmark);
        } else {
            this.dialog2a.classList.add("bg-gray-100", "dark:bg-gray-600");
            this.dialog2a.classList.remove("bg-blue-100", "dark:bg-blue-800");
            this.dialog2b.classList.add("text-gray-500", "dark:text-gray-100");
            this.dialog2b.classList.remove(
                "text-blue-600",
                "dark:text-blue-300"
            );
            this.dialog2c.setAttribute("d", this.dialog2d);
        }
    }

    render2b(isChecked: boolean) {
        if (isChecked) {
            this.dialog2.classList.remove(
                "after:border-gray-100",
                "dark:after:border-gray-600"
            );
            this.dialog2.classList.add(
                "after:border-blue-100",
                "dark:after:border-blue-800"
            );
        } else {
            this.dialog2.classList.add(
                "after:border-gray-100",
                "dark:after:border-gray-600"
            );
            this.dialog2.classList.remove(
                "after:border-blue-100",
                "dark:after:border-blue-800"
            );
        }
    }

    render3a(isChecked: boolean) {
        if (isChecked) {
            this.dialog3a.classList.remove("bg-gray-100", "dark:bg-gray-600");
            this.dialog3a.classList.add("bg-blue-100", "dark:bg-blue-800");
            this.dialog3b.classList.remove(
                "text-gray-500",
                "dark:text-gray-100"
            );
            this.dialog3b.classList.add("text-blue-600", "dark:text-blue-300");
            this.dialog3c.setAttribute("d", this.dialogCheckmark);
            this.dialog3c.removeAttribute("transform");
        } else {
            this.dialog3a.classList.add("bg-gray-100", "dark:bg-gray-600");
            this.dialog3a.classList.remove("bg-blue-100", "dark:bg-blue-800");
            this.dialog3b.classList.add("text-gray-500", "dark:text-gray-100");
            this.dialog3b.classList.remove(
                "text-blue-600",
                "dark:text-blue-300"
            );
            this.dialog3c.setAttribute("d", this.dialog3d);
        }
    }

    render3b(isChecked: boolean) {
        if (isChecked) {
            this.dialog3c.classList.remove(
                "after:border-gray-100",
                "dark:after:border-gray-600"
            );
            this.dialog3.classList.add(
                "after:border-blue-100",
                "dark:after:border-blue-800"
            );
        } else {
            this.dialog3c.classList.add(
                "after:border-gray-100",
                "dark:after:border-gray-600"
            );
            this.dialog3.classList.remove(
                "after:border-blue-100",
                "dark:after:border-blue-800"
            );
        }
    }
}
